import { useEffect, useState } from 'react'

export type Viewport = 'mobile' | 'tablet' | 'desktop'

function classify(width: number): Viewport {
  if (width < 760) return 'mobile'
  if (width < 1100) return 'tablet'
  return 'desktop'
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(() =>
    typeof window === 'undefined' ? 'desktop' : classify(window.innerWidth),
  )
  useEffect(() => {
    const onResize = () => setVp(classify(window.innerWidth))
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])
  return vp
}
